export default "__VITE_ASSET__81789da3__"